<template>
  <div
    id="export-data-modal"
    data-modal-backdrop="static"
    tabindex="-1"
    aria-hidden="true"
    class="fixed top-0 left-0 right-0 z-50 items-center justify-center hidden w-full overflow-x-hidden overflow-y-auto md:inset-0 h-modal md:h-full"
  >
    <div class="relative w-full max-w-2xl">
      <!-- Modal content -->
      <div class="relative pt-4 pb-2 bg-gray-200 rounded-lg shadow  flex flex-col items-stretch">
        <!-- Modal header -->
        <div class="px-4 flex items-center justify-between pb-1 mb-4 border-b border-gray-200 rounded-t sm:mb-5 ">
          <h3 class="text-left left font-semibold text-gray-900 text-lg ">
            <h5 class="font-semibold text-gray-900 text-lg ">
              <span class="">Exporter les données</span>
            </h5>
          </h3>

          <button
            type="button"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 inline-flex "
            @click="onClose()"
          >
            <svg aria-hidden="true" class="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
              <path
                fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd"
              />
            </svg>
            <span class="sr-only">Close modal</span>
          </button>
        </div>

        <div class="relative min-h-96 flex items-center bg-white rid gap-4 mb-4 sm:grid-cols-1 sm:gap-6 sm:mb-5 p-4">
          <div v-if="showPane('period-two-days')" class="absolute top-3 bottom-3 left-3 right-3" :class="{ hidden: !showDataFields }">
            <p class="text-base font-bold text-left text-gray-500  mb-4">Veuillez choisir la période (6 mois maximum) {{ input?.options?.exportDate }}</p>

            <div class="my-2 justify-start bg-white flex flex-row items-center">
              <span class="mx-4 text-gray-500 w-36">Depuis</span>
              <div class="relative max-w-lg">
                <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                  <svg class="w-4 h-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                    />
                  </svg>
                </div>
                <input
                  @click="onClickDateStart()"
                  id="datepicker-custom-start"
                  type="text"
                  datepicker
                  datepicker-autohide
                  data-date-format="yyyy-mm-dd"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5      "
                  placeholder="Sélectionner une date"
                />
              </div>
            </div>

            <div class="my-2 justify-start bg-white flex flex-row items-center">
              <span class="mx-4 text-gray-500 w-36">Jusqu'au</span>
              <div class="relative max-w-lg">
                <div class="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                  <svg class="w-4 h-4 text-gray-500 " aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                    <path
                      d="M20 4a2 2 0 0 0-2-2h-2V1a1 1 0 0 0-2 0v1h-3V1a1 1 0 0 0-2 0v1H6V1a1 1 0 0 0-2 0v1H2a2 2 0 0 0-2 2v2h20V4ZM0 18a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V8H0v10Zm5-8h10a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2Z"
                    />
                  </svg>
                </div>
                <input
                  @click="onClickDateEnd()"
                  id="datepicker-custom-end"
                  type="text"
                  datepicker
                  datepicker-autohide
                  data-date-format="yyyy-mm-dd"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5      "
                  placeholder="Sélectionner une date"
                />
              </div>
            </div>

            <div class="my-2">
              <div class="w-full border bg-gray-100 rounded-lg flex flex-col items-center justify-center mt-3">
                <div class="h-36 flex flex-col items-center justify-center bg-gray100">
                  <i class="fa-light fa-file-xls fa-2xl mb-6"></i>
                  <p class="hidden">
                    <span class=" ">period_start = {{ period_start_custom }}</span
                    ><br /><br />
                    <span class=" ">period_end = {{ period_end_custom }}</span>
                  </p>

                  <p class="mt-4">{{ ValidationMessage }}</p>
                </div>
              </div>
            </div>
          </div>

          <div v-if="showPane('no-period')" class="absolute top-3 bottom-3 left-3 right-3 flex justify-center items-center" :class="{ hidden: showDataFields }">
            <div class="h-16 flex items-center justify-center">Ce type extraction de données ne demande pas de filtrage. {{ disableExportButton() }}</div>
          </div>

          <div v-if="showPane('select-month')" class="absolute top-3 bottom-3 left-3 right-3 flex justify-center items-center">
            <div class="h-16 flex items-center justify-center mr-6">Sélectionner le mois du rapport.{{ month }}</div>

            <div class="w-72 h-72 justify-center flex flex-col h-full bg-white">
              <ul class="flex-column h-72 border-gray-300 border-2 border overflow-y-auto space-y space-y-1 text-sm font-medium text-gray-500  md:mb-0 justify-center px-2">
                <li v-for="month in months" :key="month.id" class="py-1">
                  <div
                    @click="onSelectMonth(month.id)"
                    class="cursor-pointer inline-flex items-center px-4 py-3 rounded-lg w-full   "
                    :class="{
                      'font-bold  bg-gray-700 text-gray-100 hover:text-gray-100 hover:bg-gray-700 focus:border-gray-400': current_period == month.id,
                      'font-bold  bg-gray-100 text-gray-900 hover:text-gray-900 hover:bg-gray-200 focus:border-gray-400': current_period != month.id,
                    }"
                  >
                    <i class="fa-solid fa-calendar-days mr-3"></i>
                    {{ month.name }}
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="flex items-center justify-between px-4">
          <div class="text-gray-500 italic text-xs">*584*</div>
          <div class="flex items-center justify-end">
            <button
              type="button"
              class="mr-3 py-2.5 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200      "
              @click="onClose()"
            >
              Annuler
            </button>
            <button
              type="button"
              :disabled="disableExportButton()"
              class="inline-flex items-center focus:ring-4 focus:outline-none focus:ring-gray-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center  "
              :class="{ ' bg-gray-600 hover:bg-gray-700 text-white': !disableExportButton(), ' bg-gray-400 hover:bg-gray-400 text-gray-100': disableExportButton() }"
              @click="onValidate"
            >
              Exporter
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// Active le datepicker de Flowbite Pro

import labels from "@/assets/lg/attribut.json";
import Datepicker from "flowbite-datepicker/Datepicker";

//import fr from "flowbite-datepicker/locales/fr";
//import fr from "flowbite-datepicker/locales/fr";

import { mapGetters } from "vuex";

export default {
  name: "ExportDataModal",
  props: {
    input: Object,
    refresh: String,
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),

    showDataFields: function () {
      if (this.input?.options?.exportDate == undefined) return true;

      return this.input?.options?.exportDate;
    },
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
    ValidationMessage: function () {
      if (!this.period_start_custom) return "Sélectionnez une date de début de période."; // Vérifie si une des dates est nulle
      if (!this.period_end_custom) return "Sélectionnez une date de fin de période. La période doit être inférieure à 3 mois."; // Vérifie si une des dates est nulle

      const date1 = new Date(this.parseFrenchDateToISO(this.period_start_custom));
      const date2 = new Date(this.parseFrenchDateToISO(this.period_end_custom));

      if (isNaN(date1)) return "Erreur : La date de début de période n'est pas valide"; // Vérifie que les dates sont valides

      if (isNaN(date2)) return "Erreur :  La date de fin de période n'est pas valide "  ; // Vérifie que les dates sont valides

      if (date1 > date2) return "Erreur : La date du début de période ne peut pas être postérieure à la date de fin de la période."; // Vérifie que D1 < D2

      // Calcul de la différence en mois
      const diffInMonths = (date2.getFullYear() - date1.getFullYear()) * 12 + (date2.getMonth() - date1.getMonth());

      if (diffInMonths < 6) return "La période est correcte pour exporter les données " ;
      return "Erreur : La période doit ne doit pas être supérieur à 3 mois.";
    },
  },
  data() {
    return {
      lg: "FR",
      labels: labels,
      price: "",
      mode: "",
      period_start: "",
      period_end: "",

      period_start_custom: "",
      period_end_custom: "",

      datepicker_start: null,
      datepicker_end: null,

      id: null,
      current_period: null,
      months: [],
      items: [],
      selected: null,
      filtered_items: [],
      query: "",
    };
  },

  watch: {
    refresh: function () {
  

      this.selected = null;
      this.current_period = null;
      this.period_start = "";
      this.period_end = "";

      this.setCurrentMonth();
      if (this.datepicker_start == null) {
   
        this.initComponent();
      }
      this.months = this.generateMonthList("2025-01-01");
    },
    input: async function () {
      //  this.id = this.input?.id

      if (this.datepicker_start == null) {
  
        this.initComponent();
      }

      this.selected = null;
      this.period_start = "";
      this.period_end = "";
    },
  },
  async mounted() {
    this.initComponent();
  },

  methods: {
    parseFrenchDateToISO: function (frenchDate) {
      if (typeof frenchDate !== "string") return null;
      const parts = frenchDate.split("/");
      if (parts.length !== 3) return null;

      const [day, month, year] = parts;
      return `${year}-${month}-${day}`; // format ISO
    },
    generateMonthList: function (startDateStr, locale = "fr") {
      const [startYear, startMonth] = startDateStr.split("-").map(Number);
      const startDate = new Date(startYear, startMonth - 1); // mois = 0-based

      const now = new Date();
      const endDate = new Date(now.getFullYear(), now.getMonth()); // mois actuel

      const result = [];
      const current = new Date(startDate);

      while (current <= endDate) {
        const year = current.getFullYear();
        const month = String(current.getMonth() + 1).padStart(2, "0");
        const id = `${year}-${month}`;

        const name = current.toLocaleDateString(locale, { month: "long", year: "numeric" });
        const formattedName = name.charAt(0).toUpperCase() + name.slice(1);

        result.push({ id, name: formattedName });

        // Passe au mois suivant
        current.setMonth(current.getMonth() + 1);
      }

      return result.reverse();
    },
    onSelectMonth: function (month) {
      if (this.current_period == month) this.current_period = null;
      else this.current_period = month;
    },
    showPane: function (type) {
      if (this.input?.type == "select-month" && type == "select-month") return true;
      if (this.input?.type == "no-period" && type == "no-period") return true;

      if (this.input?.type == "period-two-days" && type == "period-two-days") return true;
      if (this.input?.type == null && type == "no-period") return true;

      return false;
    },
    disableExportButton: function () {
      if (this.input?.type == "select-month" && this.current_period == undefined) return true;
      if (this.input?.type == "no-period") return false;
      if (this.input?.type == "period-two-days" || this.input?.type == undefined) {
     //    console.log("disableExportButton-period_start_custom ", this.period_start_custom);
     //   console.log("disableExportButton-period_end_custom ", this.period_end_custom);

        if (this.period_start_custom == null) return true;
        if (this.period_end_custom == null) return true;
        const date1 = new Date(this.period_start_custom);
        const date2 = new Date(this.period_end_custom);

        if (date2 < date1) return true;
      }

      return false;
    },
    onClickDateStart() {
      if (this.datepicker_start == undefined) this.initComponent();
      this.datepicker_start.show();
    },
    onClickDateEnd() {
      if (this.datepicker_end == undefined) this.initComponent();
      this.datepicker_end.show();
    },
    initComponent() {
      this.id = this.input?.id;
      //  this.source = this.input?.source?.source

      if (this.datepicker_start == undefined) {
        //  Object.assign(Datepicker.locales, fr);
        // set the target element of the input field
        const $datepickerEl = document.getElementById("datepicker-custom-start");

        if ($datepickerEl == undefined) return;

     //  console.log("$datepickerEl", $datepickerEl);

        // optional options with default values and callback functions
        const options = {
          format: "dd/mm/yyyy",
          autohide: true,
          language: "fr",
          rangePicker: false,
          autoSelectToday: 0,
          title: "Choisir une date ..",
        //  onShow: () => {
        //    console.log("shox");
        //  },
        //  onHide: () => {
        //    console.log("hide");
        //  },
        };

        //const instanceOptions = {
        // id: "datepicker-custom",
        // override: true,
        //};

        this.datepicker_start = new Datepicker($datepickerEl, options);

    //   console.log("datepicker_start", this.datepicker_start);
        // this.datepicker_start.setDate("05/31/2024");

        let local_data = this;

        $datepickerEl.addEventListener("changeDate", function () {
          local_data.period_start_custom = $datepickerEl.value;
        });
        // programatically show the datepicker
        //this.datepicker_start.show();
      }

      if (this.datepicker_end == undefined) {
        //  Object.assign(Datepicker.locales, fr);
        // set the target element of the input field
        const $datepickerEl2 = document.getElementById("datepicker-custom-end");

        if ($datepickerEl2 == undefined) return;

   //     console.log("$datepickerEl", $datepickerEl2);

        // optional options with default values and callback functions
        const options = {
          format: "dd/mm/yyyy",
          autohide: true,
          language: "fr",
          rangePicker: false,
          autoSelectToday: 0,
          title: "Choisir une date ..",
          onShow: () => {
            console.log("shox");
          },
          onHide: () => {
            console.log("hide");
          },
        };
        let local_data = this;

        //const instanceOptions = {
        // id: "datepicker-custom",
        // override: true,
        //};

        this.datepicker_end = new Datepicker($datepickerEl2, options);
        $datepickerEl2.addEventListener("changeDate", function () {
          local_data.period_end_custom = $datepickerEl2.value;
        });

        // console.log("datepicker_end", this.datepicker_end);
      }
    },
    setCurrentMonth() {
      /*
      const now = new Date();
      const firstDay = new Date(now.getFullYear(), now.getMonth(), 1);
      const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0);

      if (this.datepicker == undefined) return;

      this.datepicker.setDates(firstDay, lastDay);

      // Mettre à jour les variables (optionnel, pour affichage ou autre)
      const format = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

      this.period_start_custom = format(firstDay);
      this.period_end_custom = "";
      if (this.$refs.startDate != null) this.$refs.startDate.value = format(firstDay);
      if (this.$refs.endDate != null) this.$refs.endDate.value = format(lastDay);*/
    },

    getDates() {
      // Accès direct aux valeurs des inputs via refs
      if (this.datepicker_start != undefined) this.period_start_custom = this.datepicker_start.getDate();
      if (this.datepicker_end != undefined) this.period_end_custom = this.datepicker_end.getDate();
    },

    onValidate() {
      if (!this.showDataFields) {
        let item = {
          id: this.input.id,
          action: this.input.action,
          source: {
            //   id: this.input.source?.record_id,
            //   record_id: this.input.source?.record_id,
          },
          target: {
            start_period: null,
            end_period: null,
          },
        };

        this.$emit("confirm", item);
        return;
      }

      let item = {
        id: this.input.id,
        action: this.input.action,
        type: this.input?.type,
        source: {
          //   id: this.input.source?.record_id,
          //   record_id: this.input.source?.record_id,
        },
        target: {},
      };

      if (this.input.type == "select-month") {
        item.target.period = this.current_period;
      } else {
       

        const date1 = new Date(this.parseFrenchDateToISO(this.period_start_custom));
        const date2 = new Date(this.parseFrenchDateToISO(this.period_end_custom));

        if (date2 < date1) {
          return;
        }

        item.target.start_period = date1.toISOString().split("T")[0];
        item.target.end_period = date2.toISOString().split("T")[0];
      }
 
      this.$emit("confirm", item);
      // this.name = ""
    },
    onClose() {
      // if (this.datepicker != undefined) console.log("setDates", this.datepicker.setDates(null, null));
      this.$emit("close");
    },
  },
  components: {},
};
</script>
